module.exports = "/_next/static/resources/photo-2-2a75bb9929ec8ae29422b45446ea3d0f.webp";